module.exports = __webpack_public_path__ + "img/buttonTrue.3e8e8b51.png";